import { Col, Image, List, Row, Skeleton, Space, Typography } from 'antd';
import ThaiMassage from '../../assets/img/ThaiMassage.png';

const { Text } = Typography;

function ListServices({ onClickItem, dataSource, loading = false }) {
    return (
        <List
            dataSource={dataSource}
            renderItem={(item) =>
                loading ? (
                    <>
                        {Array.from({ length: 4 }).map((_, index) => (
                            <Skeleton key={index} avatar active />
                        ))}
                    </>
                ) : (
                    <List.Item
                        onClick={() => {
                            if (onClickItem) onClickItem(item);
                        }}
                    >
                        <Row
                            style={{
                                display: 'flex',
                                flexDirection: 'column',
                                rowGap: 12,
                                width: '100%',
                            }}
                        >
                            <Space>
                                <div
                                    style={{
                                        position: 'relative',
                                        width: 80,
                                        height: 80,
                                        borderRadius: 8,
                                        overflow: 'hidden',
                                    }}
                                >
                                    <Image
                                        preview={false}
                                        style={{
                                            borderRadius: 8,
                                            height: 80,
                                            width: 80,
                                            objectFit: 'cover',
                                            background: 'linear-gradient(to top, #0e3d39 0%, #0e3d39 80.33%, #0e3d3900 100%)',
                                        }}
                                        src={item?.image}
                                        onError={(e) => {
                                            e.target.onerror = null;
                                            e.target.src = ThaiMassage;
                                        }}
                                    />
                                    <div
                                        style={{
                                            position: 'absolute',
                                            inset: 0,
                                            background: 'linear-gradient(to top, #0E3D39,transparent)',
                                        }}
                                    />
                                </div>
                                <Space direction="vertical">
                                    <Text strong>{item?.name}</Text>
                                    <Text type="secondary">{item?.description}</Text>
                                </Space>
                            </Space>
                            <Row justify="space-between" align="middle">
                                <Col>
                                    <Text>{item?.booking_count}+ service booked</Text>
                                </Col>
                                <Col>
                                    <Text>
                                        <Text strong>฿{item?.price}</Text>
                                        <Text type="secondary">/ {item?.duration} min</Text>
                                    </Text>
                                </Col>
                            </Row>
                        </Row>
                    </List.Item>
                )
            }
        />
    );
}

export default ListServices;
